import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { App } from './App.js';
import { isAuthResponseWindow } from './lib/authResponseWindow.js';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

if (isAuthResponseWindow()) {
  void broadcastResponseToMainFrame();
} else {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
